import script from "./IELTS.vue?vue&type=script&setup=true&lang=ts"
export * from "./IELTS.vue?vue&type=script&setup=true&lang=ts"

import "./IELTS.vue?vue&type=style&index=0&id=0996bba7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0996bba7"]])

export default __exports__